<template>
  <Transition name="toast">
    <div
        v-if="visible"
        class="toast"
        :class="positionClass"
        @mouseenter="pauseTimer"
        @mouseleave="resumeTimer"
    >
      <div class="toast-content">
        <span class="toast-text">{{ message }}</span>
<!--        <button class="toast-close" @click="close" v-if="closeable">-->
<!--          ×-->
<!--        </button>-->
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

// eslint-disable-next-line no-undef
const props = defineProps({
  message: {
    type: String,
    required: true
  },
  duration: {
    type: Number,
    default: 3000
  },
  position: {
    type: String,
    default: 'top'
  },
  closeable: {
    type: Boolean,
    default: false
  }
})

// eslint-disable-next-line no-undef
const emit = defineEmits(['close'])

const visible = ref(false)
const timer = ref(null)
const isPaused = ref(false)

const positionClass = ref(`toast-${props.position}`)

const close = () => {
  clearTimeout(timer.value)
  visible.value = false
  setTimeout(() => {
    emit('close')
  }, 300)
}

const pauseTimer = () => {
  if (props.duration === 0) return
  isPaused.value = true
  clearTimeout(timer.value)
}

const resumeTimer = () => {
  if (props.duration === 0) return
  isPaused.value = false
  timer.value = setTimeout(close, props.duration)
}

onMounted(() => {
  visible.value = true
  if (props.duration > 0) {
    timer.value = setTimeout(close, props.duration)
  }
})

onUnmounted(() => {
  clearTimeout(timer.value)
})
</script>

<style scoped>
.toast {
  position: fixed;
  z-index: 9999;
  left: 50%;
  transform: translateX(-50%);
  max-width: 19rem;
  text-align: center;
  font-size: 1.4rem;
  background: rgba(30,30,30,0.9);
  border-radius: 0.8rem 0.8rem 0.8rem 0.8rem;
  padding: 1rem 1.5rem;
  color: #FFFFFF;
}

.toast-top {
  top: 22.6rem;
}

.toast-bottom {
  bottom: 20px;
}

.toast-center {
  top: 50%;
  transform: translate(-50%, -50%);
}

.toast-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.toast-text {
  flex: 1;
  word-break: break-word;
}

.toast-close {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  opacity: 0.7;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.toast-close:hover {
  opacity: 1;
}

/* 动画效果 */
.toast-enter-active {
  animation: fade-in-down 0.3s;
}

.toast-leave-active {
  animation: fade-out-up 0.3s;
}

@keyframes fade-in-down {
  from {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}

@keyframes fade-out-up {
  from {
    opacity: 1;
    transform: translate(-50%, 0);
  }
  to {
    opacity: 0;
    transform: translate(-50%, -20px);
  }
}

</style>
